import Vue from "vue";
import Vuex from "vuex";
import VueTouch from "vue-touch";
import store from "./store";
import router from "./Routes";
import App from "./App.vue";
import Widget from "./components/Widget/Widget";
import axios from "axios";
import { moneyfiltro, currencyFilter } from "@/filters";
import { VueSpinners } from "@saeris/vue-spinners";
import Chartkick from "vue-chartkick";
import Chart from "chart.js";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueSession from "vue-session";

import "./plugins/quasar";

Vue.prototype.$eventHub = new Vue();

Vue.use(VueSession);
Vue.use(VueSweetalert2);
Vue.use(Chartkick.use(Chart));
Vue.use(VueSpinners);
Vue.use(VueTouch);
Vue.use(Vuex);

Vue.component("Widget", Widget);
Vue.use(require("vue-moment"));
Vue.filter("moneyfiltro", moneyfiltro);
Vue.filter("currencyFilter", currencyFilter);

Vue.config.productionTip = false;

fetch("/serverconfig.json")
  .then((res) => res.json())
  .then((data) => {
    axios.defaults.baseURL = data.baseURL;

    Vue.prototype.$RutaApiReniec = data.RutaApiReniec;
    Vue.prototype.$RutaApiXml = data.RutaApiXml;
    Vue.prototype.$mainurl = data.baseURL;

    Vue.directive("model", {
      bind(el, binding, vnode) {
        el.oninput = () => (vnode.context[binding.expression] = el.value);
      },
    });

    new Vue({
      el: "#app",
      store,
      router,
      render: (h) => h(App),
    });
  })
  .catch((err) => {
    console.error("Error al cargar serverconfig.json", err);
    new Vue({
      el: "#app",
      store,
      router,
      render: (h) => h(App),
    });
  });
